import { render, staticRenderFns } from "./PCIndexPage.vue?vue&type=template&id=5f75d89c&scoped=true"
import script from "./PCIndexPage.vue?vue&type=script&lang=js"
export * from "./PCIndexPage.vue?vue&type=script&lang=js"
import style0 from "./PCIndexPage.vue?vue&type=style&index=0&id=5f75d89c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f75d89c",
  null
  
)

export default component.exports